import { v4 as uuidv4 } from 'uuid';
import { getUserAgent } from '../utils/getUserAgent.js';
import { uploadFileInAndroid } from './androidHelper.js';
import { deleteCaseRequest, getBinaryData, getCaseDetailsObject, } from './referenceHelper.js';
export const removeUnacceptableCharacter = (obj) => Object.entries(obj).reduce((acc, [key, value]) => ({
    ...acc,
    [key]: value?.replace(/,/g, '').replace(/(?<temp1>[ -./])\1+/g, '$1') ?? '',
}), {});
export const getExternalToken = async (jwt, brand, svcIdvClient) => await svcIdvClient.generateExternalIDVToken({
    jwt,
    brand,
    sessionId: uuidv4(),
});
export const createDossier = async (individualData, createJwt, idvLabClient) => {
    const addresses = removeUnacceptableCharacter(individualData.addresses);
    const body = {
        journeyReferenceId: individualData.caseRefNumber,
        profile: 'profile1',
        personal: {
            firstname: individualData.personalDetails?.firstname,
            surname: individualData.personalDetails?.surname,
            dateOfBirth: individualData.personalDetails?.dateOfBirth,
            otherName: individualData.personalDetails?.middlename,
        },
        nationality: {
            nationality: individualData?.nationalities?.countryCode || '',
        },
        addresses,
    };
    const headers = {
        'X-ACCESS-TOKEN': createJwt.jwt,
        'Content-Type': 'application/json',
    };
    const response = await idvLabClient.post('/dossier', body, {
        headers,
    });
    return response;
};
export const retrieveDossier = async (createJwt, createDossierResponse, idvLabClient) => {
    const headers = {
        'X-ACCESS-TOKEN': createJwt.jwt,
        'Content-Type': 'application/json',
    };
    const response = await idvLabClient.get(`/dossier/${createDossierResponse.guid}`, {
        headers,
    });
    return response;
};
export const retrieveCaseDetails = async (individualData, createJwt, iaLabClient) => {
    const headers = {
        'X-ACCESS-TOKEN': createJwt.jwt,
    };
    const response = await iaLabClient.get(`/cases/${individualData.caseRefNumber}`, {
        headers,
    });
    return response;
};
export const docUploadInCWA = async (ialabJWT, formData, iaLabClient) => {
    const headers = {
        'X-ACCESS-TOKEN': ialabJWT,
        'Content-Type': 'multipart/form-data',
    };
    const response = await iaLabClient.post('/cases/files', formData, {
        headers,
    });
    return response;
};
export const docUploadHandler = async (createJwt, getCaseDetails, type, document, iaLabClient) => {
    const userAgent = getUserAgent();
    const caseDetailsObject = getCaseDetailsObject(getCaseDetails, type);
    const ialabJWT = createJwt.jwt;
    const uploadedFile = getBinaryData(type, document);
    let response;
    if (uploadedFile) {
        if (userAgent === 'Android webview') {
            response = await uploadFileInAndroid(ialabJWT, uploadedFile, caseDetailsObject, iaLabClient);
            return response;
        }
        else {
            const formData = new FormData();
            formData.append('caseDetails', JSON.stringify(caseDetailsObject));
            formData.append('fileSegments', uploadedFile);
            response = await docUploadInCWA(ialabJWT, formData, iaLabClient);
            return response;
        }
    }
    return null;
};
export const verifyDocuments = async (createJwt, createDossierResponse, idvLabClient) => {
    const headers = {
        'X-ACCESS-TOKEN': createJwt.jwt,
        'Content-Type': 'application/json',
    };
    const response = await idvLabClient.post('/documents/verifications/verify', {
        guid: createDossierResponse.guid,
    }, {
        headers,
    });
    return response;
};
export const deleteDuCall = async (getOldDocDetails, deleteObj, createJwt, iaLabClient) => {
    const header = {
        'X-ACCESS-TOKEN': createJwt.jwt,
    };
    const url = '/cases/files?_method=DELETE';
    const deleteCalls = getOldDocDetails.map((doc) => {
        const body = deleteCaseRequest(doc, deleteObj);
        return iaLabClient.post(url, body, {
            headers: header,
        });
    });
    await Promise.all(deleteCalls);
};
//# sourceMappingURL=apiHelper.js.map